module.exports = __webpack_public_path__ + "static/media/image-13.c64de3f9.png";